export enum ErrorCode {
	NOT_LINKED = 'notLinked',
	CANNOT_EMBED = 'cannotEmbed',
	ENGAGE_REDIRECT = 'engageRedirect',
	DEFAULT = 'default',
	REFRESH_REQUIRED = 'refreshRequired'
}
